import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "p-mt-3" }, [
  /*#__PURE__*/_createTextVNode(" This attribute is related to "),
  /*#__PURE__*/_createVNode("a", {
    href: "http://www.fiware.org",
    target: "_blank"
  }, "Fiware"),
  /*#__PURE__*/_createTextVNode(" project, more specifically to "),
  /*#__PURE__*/_createVNode("a", {
    href: "http://catalogue.fiware.org/enablers/publishsubscribe-context-broker-orion-context-broker",
    target: "_blank"
  }, " Orion Context Broker (OCB)"),
  /*#__PURE__*/_createTextVNode(". It permits to NOT define JSON path Items, Attributes and Headers if the response is from OBC, a NGSI implementation. So if you use the REST DataSet to retrieve information from OCB then you don't need to define items and attributes because the format of JSON Response is well known. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    header: _ctx.$t('managers.datasetManagement.helpTitle'),
    style: _ctx.detailDescriptor.style.infoDialog,
    visible: _ctx.visible,
    modal: true,
    class: "p-fluid kn-dialog--toolbar--primary",
    closable: false
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["header", "style", "visible"]))
}